import { Logger } from '@services/logger/Logger';
import { Measurement, Tags, TagBuilder } from '@services/measurement';
import { AppContextData } from '@contexts/app/AppContextData';
import { RequestHeader, AgHeader } from './model/request/Header';

export class Api {
    private readonly metricName: string;
    protected readonly measurement: Measurement;

    protected readonly logger: Logger;
    protected readonly appContext: AppContextData;

    constructor(appContext: AppContextData, measurement: Measurement, logger: Logger, metricName: string) {
        this.appContext = appContext;
        this.logger = logger;
        this.metricName = metricName;
        this.measurement = measurement;
    }

    protected measureP = <TRes>(tags?: Tags | TagBuilder<TRes>) => (measured: Promise<TRes>) => {
        return this.measurement.measurePromise(this.metricName, measured, tags);
    };

    /**
     * build AG-* headers for when we can connect our services directly, without WebGate
     */
    protected buildAgHeader = (): RequestHeader | {} => {
        const headers = [];
        if (!!this.appContext.sessionId) {
            headers.push({ [AgHeader.AnalyticsSessionId]: this.appContext.sessionId });
        }
        if (!!this.appContext.devicePlatformId) {
            headers.push({ [AgHeader.DeviceTypeId]: `${this.appContext.devicePlatformId}` });
        }
        if (!!this.appContext.origin) {
            headers.push({ [AgHeader.Origin]: this.appContext.origin });
        }
        if (!!this.appContext.userId) {
            headers.push({ [AgHeader.UserId]: this.appContext.userId });
        }
        if (!!this.appContext.whitelabelId) {
            headers.push({ [AgHeader.Whitelabel]: `${this.appContext.whitelabelId}` });
        }
        if (!!this.appContext.languageId) {
            headers.push({ [AgHeader.LanguageId]: `${this.appContext.languageId}` });
        }

        return Object.assign({}, ...headers);
    };
}
